import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class CellService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
             ) { }


   getCell(isActive:number=-1) {
        
    let isAvailable: string ="?active="+isActive;

    if(isActive==-1){
        isAvailable="";
    }
        return this.http.get(this.global.httpUrl+"cells"+isAvailable);
    }

   getCellByFilter( filter: any[],page: number = 0,isActive:number=-1) {
        let url = "";

         if(page){
          url = "page="+page + "&";
         }

        for (var item of filter) {
            url += item.name + "=" + item.value + "&";
        }
        url = url.substring(0,url.length-1);
        
        let isAvailable: string ="&active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

      return this.http.get(this.global.httpUrl+"cells?"+url+isAvailable);
}  
   
   getCellById(id: any) {
        return this.http.get(this.global.httpUrl+"cells/"+id);
    } 

   createCell(data: any){
        return this.http.post(this.global.httpUrl+"cells", data);
    }

   updateCell(data: any,id: any){
        return this.http.put(this.global.httpUrl+"cells/"+id, data);
    } 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/cells/cell.service.ts